//export const API_url = "http://localhost:8080";
export const API_url = "http://api.xprsoft.com";
//export const API_url = "http://31.220.21.212:8090";